import { Container, Row, Col } from "reactstrap";


function CityContact({title, address, phone, email}) {
  return (
    <Col md="6">
      <h4 style={{marginBottom: 20}}>{title}</h4>
      <Container>
        <Row>
          <Col md="12"><i className="nc-icon nc-pin-3 mr-4" />{address}</Col>
        </Row>
        <Row>
          <Col md="12"><i className="nc-icon nc-mobile mr-4" />{phone}</Col>
        </Row>
        <Row>
          <Col md="12"><i className="nc-icon nc-email-85 mr-4" />{email}</Col>
        </Row>
      </Container>
    </Col>
  )
}


function TopRangeContacts () {

  return (
    <div className="section section-dark landing-section" id="contacts">
      <Container style={{color: "#fff"}}>
        <h2 style={{margin: 0}}>Контакты TOPRANGE:</h2>
        <Row >

          <CityContact
            title={"Главный офис в Москве"}
            address={"г. Москва, Ракетный бульвар, д. 16"}
            phone={"+7 495 775 44 11, +7 980 397 72 31"}
            email={"service.ru@toprange-group.com"}
          />

          <CityContact
            title={"Филиал в Санкт-Петербурге"}
            address={"г. Санкт-Петербург, Тамбовская улица, д. 12"}
            phone={"+7 495 775 44 11"}
            email={"service.ru@toprange-group.com"}
          />

        </Row>
      </Container>
    </div>
  )
}

export default TopRangeContacts;